export default (month) => {
  return (dispatch) => {
    dispatch({
      type: "MONTH",
      month,
    })
  }
}
